import {createGlobalStyle} from 'styled-components';
import {down} from 'styled-breakpoints';

import '../assets/fonts/fonts.css';

const GlobalStyle = createGlobalStyle`
  html{
  scrollbar-width: none;
  }
  body {
    box-sizing: border-box;
    background: #000;
    font-size: ${(props) => props.theme.fontSizes.text};
    font-family: 'Raleway';

    line-height: ${(props) => props.theme.lineHeights.text};
    color: ${(props) => props.theme.colors.white};
   
    ::-webkit-scrollbar {
      width: 0 !important;
      }
    }
  *,
  *::after,
  *::before { 
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  a{
    color: inherit;
    text-decoration: none;
    font-family: inherit;
  }


  .container {
    width: 70%;
    margin: auto;
    height: 100%;
  }
  ${down('md')} {
    .container {
    width: 100%;
  }
    }

`;

export default GlobalStyle;
